// Text diagram element (spec §7). The Connect-native target a Desktop `.pipe`
// text annotation maps into (F2). A pure visualization object — it does not affect
// the solver. `position` is in Connect canvas coordinates (Y-down), transformed on
// import with the same positionScale + Y-mirror as vertices/edges (F2, finding §2.9).

import { z } from 'zod';
import { PointSchema, RgbaSchema } from '../base/common';

export const TextElementSchema = z.object({
  id: z.string(),
  kind: z.literal('text'),
  position: PointSchema,
  text: z.string(),
  color: RgbaSchema.optional(),
  /** Point size; absent → the renderer's default. */
  fontSize: z.number().positive().optional(),
  /** Editing lock carried over from Desktop. */
  locked: z.boolean().default(false),
});

export type TextElement = z.infer<typeof TextElementSchema>;
